<ng-sidebar-container>
  <ng-sidebar *ngIf="sideBarShow" [(opened)]="sideBarOpen" position="right" [animate]="sideBarAnimate" [keyClose]="false">
    <div class="sidebar-fix" >

      <div *ngIf="selected!=null">
        <div class="sidebar header-spacing"></div>
        <!--<ngx-form-module title="Public" [(value)]="selected.public"></ngx-form-module>-->
        <ngx-form-customer [enabled]="selected?.content == null" title="Customer" [(value)]="$any(selected).business" ></ngx-form-customer>


        <div *ngIf="selected.content != null">
          <ngx-form-text title="Title ({{selected?.title?.length}}/60)" [(value)]="selected.title"></ngx-form-text>
          <ngx-form-text title="Location ({{selected?.location?.length}}/40)" [(value)]="selected.location"></ngx-form-text>
          <ngx-form-date title="Date" [(value)]="selected.date"></ngx-form-date>
          <ngx-form-date title="Date To" [(value)]="selected.dateTo"></ngx-form-date>

          <ngx-form-area title="Summary ({{selected?.purpose?.length}}/400)" [(value)]="selected.purpose"></ngx-form-area>
          <ngx-form-text title="Changelog text" [(value)]="selected.comment"></ngx-form-text>


          <ngx-form-participant title="Participants" [(value)]="selected.participants" [edit]="true" [businessId]="selected.business._id"></ngx-form-participant>
          <ngx-form-upload title="Pictures for description" url="/api/v1/upload" [hideComment]="false" [hideCheckbox]="true" 
            [(files)]="selected.files" accept="image/jpeg"></ngx-form-upload>
          <br>
          <ngx-form-upload title="Document attachments" url="/api/v1/upload" [hideComment]="false" [hideCheckbox]="false" 
            [(files)]="selected.pdfs" accept="application/pdf"></ngx-form-upload>

        </div>
        <div *ngIf="selected.content == null">
          <hr>
          <div class="row">
            <div class="col-4"><label>Generate</label></div>
            <div class="col-2" *ngIf="!selected.planned"><button class="btn btn-primary btn-full-width" (click)="generateQuickNote(selected)" [disabled]="selected.business==null">Quick Note</button></div>
            <div class="col-2" *ngIf="!selected.planned"><button class="btn btn-primary btn-full-width" (click)="generateNote(selected)" [disabled]="selected.business==null">Note</button></div>
            <div class="col-2"><button class="btn btn-primary btn-full-width" (click)="generateVR(selected)" [disabled]="selected.business==null">Visit Report</button></div>
          </div>
          <div class="row">
            <div class="col-4"></div>
            <div class="col-2" *ngIf="!selected.planned"><button class="btn btn-primary btn-full-width" (click)="generateOnlineMeeting(selected)" [disabled]="selected.business==null">Online Meeting</button></div>
            <div class="col-2"><button class="btn btn-primary btn-full-width" (click)="generateTradeShowMeeting(selected)" [disabled]="selected.business==null">Trade Show Meeting</button></div>
            <div class="col-2"><button class="btn btn-primary btn-full-width" (click)="generateOnSiteMeeting(selected)" [disabled]="selected.business==null">Meeting at NRK Facility</button></div>
            <div class="col-2"><button class="btn btn-primary btn-full-width" (click)="generateProjectSummary(selected)" [disabled]="selected.business==null">Sample Request</button></div>
          </div>
          <div class="row" *ngIf="!selected.planned">
            <div class="col-4"></div>
            <div class="col-2"><button class="btn btn-primary btn-full-width" (click)="generateOffer(selected)" [disabled]="selected.business==null">Offer</button></div>
            <div class="col-2"><button class="btn btn-primary btn-full-width" (click)="generateOrder(selected)" [disabled]="selected.business==null">Order</button></div>
            <div class="col-2"><button class="btn btn-primary btn-full-width" (click)="generateOrderConfirmation(selected)" [disabled]="selected.business==null">OrderConfirmation</button></div>
            <div class="col-2"><button class="btn btn-primary btn-full-width" (click)="generateInvoice(selected)" [disabled]="selected.business==null">Invoice</button></div>
          </div>
        </div>
        <div *ngIf="selected.content?.type == ActivityContentType.VisitReport 
          || selected.content?.type == ActivityContentType.Note 
          || selected.content?.type == ActivityContentType.OnlineMeeting
          || selected.content?.type == ActivityContentType.TradeShowMeeting
          || selected.content?.type == ActivityContentType.OnSiteMeeting
          ">
          <ngx-form-list title="Topics" [(value)]="$any(selected.content).topics" [columns]="visitReportColumns" (valueChange)="changeVR(selected, $event)" (editConfirm)="validateVR($event)" [canDelete]="true" [sort]="true"></ngx-form-list>
        </div>

        <hr>
        <ngx-form-project *ngIf="selected.content != null 
          && selected.content?.type != ActivityContentType.VisitReport 
          && selected.content?.type != ActivityContentType.Note 
          && selected.content?.type != ActivityContentType.OnlineMeeting
          && selected.content?.type != ActivityContentType.TradeShowMeeting
          && selected.content?.type != ActivityContentType.OnSiteMeeting
          " [(value)]="$any(selected).project" [projects]="selected?.business?.projects" title="Project"></ngx-form-project>
      </div>

      <div class="sidebar header-spacing"></div>

      <div class="sidebar header">
        <div class="pull-right" *ngIf="selected?.draft">
          <button class="btn btn-default btn-sm">
            <i class="ion-ios-undo" (click)="revert()"></i>
          </button>
        </div>
        <h1>{{ selected?.planned ? 'Planned ' : ''}}{{getActivityType(selected?.content?.type)}} - {{selected?.title}}
          <ng-container *ngIf="selected?.content?.type == ActivityContentType.VisitReport 
            || selected?.content?.type == ActivityContentType.Note 
            || selected?.content?.type == ActivityContentType.OnlineMeeting
            || selected?.content?.type == ActivityContentType.TradeShowMeeting
            || selected?.content?.type == ActivityContentType.OnSiteMeeting
          ">
            <a *ngIf="selected._id != null" [routerLink]="[]" (click)="openVR(selected)">
              <span>{{getVersionCode(selected)}}</span>&nbsp;
              <i class="ion-document-text"></i>
            </a>
            <span *ngIf="selected._id == null">{{getVersionCode(selected)}}</span>
          </ng-container>
        </h1>
      </div>
      <div class="sidebar footer">
        <div class="row">
          <!-- <div class="col-4"> -->
            <!--<span *ngFor="let v of selected.versions"><a [routerLink]="" (click)="openVR(v)">V{{v.version}}</a>&nbsp;</span>-->
          <!-- </div> -->

          <!-- <div *ngIf="!isPreview && selected" class="col-8"  style="width:100%;text-align:center;">
            <button class="btn btn-default btn-md" (click)="cancel()" >Cancel</button>
            <button *ngIf="!selected.draft && selected._id != null" class="btn btn-primary btn-md" (click)="saveVersion(selected)" [disabled]="isSaving">Save</button>
            <button *ngIf="selected.draft || isNoteOrVR() || selected._id == null" class="btn btn-primary btn-md"
              (click)="saveVersion(selected)" [disabled]="isSaving">{{selected.draft || selected._id == null? 'Save' : 'Save new version'}}</button>
            <button *ngIf="selected.draft|| selected._id == null" class="btn btn-default btn-md" 
              (click)="cancelDraft(selected)" >Cancel Draft</button>
            <button class="btn btn-info btn-md" (click)="saveDraft(selected)" [disabled]="isSaving">Save Draft</button>
            <button *ngIf="!isNoteOrVR() && showMergeOrZipButton()" class="btn btn-info btn-md" (click)="pdfPreview(selected, downloadType.zipAttachments)">ZIP attachments</button>
            <button *ngIf="isNoteOrVR()" class="btn btn-info btn-md" (click)="isPreview=true">Download</button>
          </div> -->
          <div *ngIf="!isPreview && selected" class="col-8"  style="width:100%;text-align:center;">
            <button class="btn btn-default btn-md" (click)="cancel(selected)" >Cancel</button>
            <button class="btn btn-primary btn-md" (click)="saveVersion(selected)" [disabled]="isSaving">Save{{ selected.planned ? ' Planned' : ''}}</button>
            <button *ngIf="selected.draft || selected._id == null" class="btn btn-danger btn-md" 
              (click)="cancelDraft(selected)" >Cancel{{ selected.planned ? ' Planned' : ''}} Draft</button>
            <button *ngIf="selected.draft || selected._id == null" class="btn btn-info btn-md" (click)="saveDraft(selected)" [disabled]="isSaving">Save{{ selected.planned ? ' Planned' : ''}} Draft</button>
            <button *ngIf="!isNoteOrVRorOM() && showMergeOrZipButton()" class="btn btn-info btn-md" (click)="pdfPreview(selected, downloadType.zipAttachments)">ZIP attachments</button>
            <button *ngIf="isNoteOrVRorOM()" class="btn btn-info btn-md" (click)="isPreview=true">Download</button>
            <button *ngIf="turnIntoActivity(true)" class="btn btn-primary btn-md" (click)="turnIntoActivity()">Turn into completed activity</button>
            <button class="btn btn-primary btn-md" (click)="openBusinessEdit(); businessEditWindow.show()" [disabled]="!selected?.business">Edit Business</button>
          </div>
          <div *ngIf="!isPreview" class="col-4">
            <ngx-form-dropdown title="Save options" displayField="value" keyField="key" [(value)]="saveOptionValue" [options]="saveOptions"></ngx-form-dropdown>
          </div>

          <div *ngIf="isPreview" style="width:100%;text-align:center;">
            <button class="btn btn-default btn-md" (click)="isPreview=false">Back</button>
            <button class="btn btn-info btn-md" (click)="pdfPreview(selected, downloadType.document)">Document</button>
            <!-- <button *ngIf="showMergeOrZipButton()" class="btn btn-info btn-md" (click)="pdfPreview(selected, downloadType.merged)">Merge document with attachments</button> -->
            <button *ngIf="showMergeOrZipButton()" class="btn btn-info btn-md" (click)="pdfPreview(selected, downloadType.zipMerged)">ZIP (document & attachments)</button>
            <button *ngIf="showMergeOrZipButton()" class="btn btn-info btn-md" (click)="pdfPreview(selected, downloadType.zipAttachments)">ZIP (attachments only)</button>
            <button *ngIf="showMergeOrZipButton()" class="btn btn-info btn-md" (click)="pdfPreview(selected, downloadType.pdfAndZip)">PDF & ZIP</button>
          </div>

        </div>
      </div>
      <div *ngIf="selected==null"><label>Nothing selected</label></div>
    </div>

    <nrk-window #businessEditWindow [style]="{ 'width': '90rem', 'min-height': '30rem' }">
      <nrk-header><b>Edit Business</b></nrk-header>
      <nrk-content>
        <ngx-business-edit *ngIf="editBusiness"
                            [item]="editBusiness"
                            [general]="editBusinessGeneral"
                            [isSaving]="isSaving"
                            [showHeader]="false"
                            [showFooter]="false"></ngx-business-edit>
      </nrk-content>
      <nrk-footer>
        <div class="row">
          <div class="mx-auto">
            <button class="btn btn-default btn-sm" (click)="businessEditWindow.hide()">Back</button>
            <button class="btn btn-primary btn-sm" (click)="saveBusiness(editBusiness)" [disabled]="isSaving">Save</button>
          </div>
        </div>
      </nrk-footer>
    </nrk-window>
  </ng-sidebar>

  <div ng-sidebar-content>
    <ngx-page-container>
      <button class="btn btn-default btn-lg pull-right" (click)="refresh()"><i class="nb-loop"></i></button>
      <button class="btn btn-default btn-lg pull-right" (click)="create()"><i class="nb-compose"></i> Create New Activity</button>
      <button class="btn btn-default btn-lg pull-right" (click)="create(true)"><i class="nb-compose"></i> Create Planned Activity</button>

      <h1>Activities</h1>
      <ngx-search [(value)]="search"></ngx-search>

      <div>
        <div>
          <nb-radio-group name="showPlanned" [(ngModel)]="showPlanned" style="display:inline-flex">
            <nb-radio [value]="undefined">Show All</nb-radio>
            <nb-radio [value]="1">Show Planned Only</nb-radio>
            <nb-radio [value]="2">Show Completed Only</nb-radio>
          </nb-radio-group>
          <div style="display:inline-block; padding-right:2rem">
            <ngx-doc-form-checkbox [(value)]="showPreparedByOwnerOnly" (valueChange)="filter(search, activities)" label=" Show prepared by me only."></ngx-doc-form-checkbox>
          </div>
        </div>
        <div>
          <a [routerLink]="[]" (click)="showReportUI = !showReportUI">report {{showReportUI ? '▲' : '▼'}}</a>
          <div class="m-3 text-center" *ngIf="showReportUI">
            <ngx-form-date [(value)]="reportFilter.dateFrom" title="Date From:"></ngx-form-date>
            <ngx-form-date [(value)]="reportFilter.dateTo" title="Date To:"></ngx-form-date>
            <div class="m-3">
              <button class="nrk-button mr-4" (click)="downloadReport(false, showPlanned)">Download Activities PDF</button>
              <!-- <button class="nrk-button mr-4" (click)="downloadReport(false, true)">Download Planned Activities PDF</button> -->
              <button class="nrk-button mr-4" (click)="downloadReport(true, showPlanned)">Download Activities XLS</button>
              <!-- <button class="nrk-button mr-4" (click)="downloadReport(true, true)">Download Planned Activities XLS</button> -->
            </div>
          </div>
        </div>
      </div>

      <pagination-controls (pageChange)="p = $event"></pagination-controls>

      <table class="table table-hover" style="margin-top: 1rem;">
        <thead>
        <tr>
          <th scope="col" class="cursor-pointer text" (click)="sort.dir = sort.col === 'type' ? -sort.dir : 1; sort.col = 'type'">Type
            <ng-container *ngIf="sort.col === 'type'">{{ sort.dir === 1 ? '▲' : '▼' }}</ng-container>
          </th>
          <th scope="col" class="cursor-pointer text-left" (click)="sort.dir = sort.col === 'owner' ? -sort.dir : 1; sort.col = 'owner'">{{!showPreparedByOwnerOnly ? 'Owner / ' : '' }} RSM
            <ng-container *ngIf="sort.col === 'owner'">{{ sort.dir === 1 ? '▲' : '▼' }}</ng-container>
          </th>
          <th scope="col" class="cursor-pointer text-center" (click)="sort.dir = sort.col === 'name' ? -sort.dir : 1; sort.col = 'name'">Customer
            <ng-container *ngIf="sort.col === 'name'">{{ sort.dir === 1 ? '▲' : '▼' }}</ng-container>
          </th>
          <th scope="col" class="cursor-pointer text-center" (click)="sort.dir = sort.col === 'location' ? -sort.dir : 1; sort.col = 'location'">Location
            <ng-container *ngIf="sort.col === 'location'">{{ sort.dir === 1 ? '▲' : '▼' }}</ng-container>
          </th>
          <th scope="col" class="cursor-pointer text" (click)="sort.dir = sort.col === 'title' ? -sort.dir : 1; sort.col = 'title'">Title
            <ng-container *ngIf="sort.col === 'title'">{{ sort.dir === 1 ? '▲' : '▼' }}</ng-container>
          </th>
          <th scope="col" class="cursor-pointer text-center" (click)="sort.dir = sort.col === 'date' ? -sort.dir : -1; sort.col = 'date'">Date
            <ng-container *ngIf="sort.col === 'date'">{{ sort.dir === 1 ? '▲' : '▼' }}</ng-container>
          </th>
          <th scope="col" class="cursor-pointer text-center" (click)="sort.dir = sort.col === 'status' ? -sort.dir : 1; sort.col = 'status'">Status
            <ng-container *ngIf="sort.col === 'status'">{{ sort.dir === 1 ? '▲' : '▼' }}</ng-container>
          </th>
          <th scope="col" class="cursor-pointer text-center"></th>
          <th scope="col" class="cursor-pointer text-center"></th>
          <th scope="col" class="cursor-pointer text-center"></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let item of filter(search, activities) | paginate: { itemsPerPage: 14, currentPage: p }"
            [class.table-success]="!item.draft && !item.planned && item.public && !item.hide && item.status !== activityStatus.cancelled"
            [class.table-warning]="!item.draft && item.public && item.hide && item.status !== activityStatus.cancelled"
            [class.planned]="!item.draft && item.public && item.planned && item.status !== activityStatus.cancelled"
            [class.table-info]="item.draft"
            [ngStyle]="{ 
              backgroundColor: activityStatusData.get(item.status).color ? activityStatusData.get(item.status).color : null, 
              opacity: activityStatusData.get(item.status).opacity ? activityStatusData.get(item.status).opacity : null
            }"
          >
          <td class="text">
            <p *ngIf="!isNoteOrVRorOM(item)">{{item.planned ? 'Planned ' : ''}}{{getActivityType(item.content?.type)}}</p>
            <p *ngIf="isNoteOrVRorOM(item) && item._id != null">{{item.planned ? 'Planned ' : ''}}{{getActivityType(item.content?.type)}}<br>
              <a [routerLink]="[]" (click)="openVR(item)">
              <!--{{getActivityType(item.content?.type)}}-->
              {{getVersionCode(item)}}
            </a></p><br>

          </td>

          <td class="text-left" (click)="showNews(item._id)"><span *ngIf="!showPreparedByOwnerOnly">{{item.owner.short}} / </span>{{$any(item.business.manager)?.title}}</td>

          <td class="text-center" (click)="showNews(item._id)">{{item.business?.name}}</td>
          <!--<td class="text">{{item.purpose}}</td>-->

          <td class="text-center" (click)="showNews(item._id)">{{item.location}}</td>
          <td class="text" (click)="showNews(item._id)">{{item.title}}<ng-container *ngIf="+item.status === 2 && item.cancelReason"><br><i>Cancel Reason: {{item.cancelReason}}</i></ng-container></td>
          <!--<td  class="text-center">{{item.project}}</td>-->
          <!--<td  class="text-center">{{item.subproject}}</td>-->
          <td class="text-center" (click)="showNews(item._id)">{{item.date  | date: 'yyyy-MM-dd'}}<span *ngIf="item.dateTo"> to {{item.dateTo | date: 'yyyy-MM-dd'}}</span></td>
          <!--<td class="text"></td>-->
          <td class="text-center">{{activityStatusData.get(item.status).name}}</td>
          <td class="text-center ico-btn">
            <button *ngIf="item.status === 1" type="button" class="btn btn-secondary btn-sm" (click)="setItemStatus(item, activityStatus.cancelled)" title="Cancel Activity">
              <nb-icon icon="close-outline"></nb-icon>
            </button>
          </td>
          <td class="text-center ico-btn" style="width:3rem">
            <button *ngIf="!item.status || item.status < 3" type="button" class="btn btn-danger btn-sm" (click)="setItemStatus(item, activityStatus.deleted)" title="Delete Activity">
              <nb-icon icon="trash-2-outline"></nb-icon>
            </button>
          </td>
          <td class="text-right">


            <!-- <button class="btn btn-default btn-sm" (click)="toggleSidebar(item)"><i class="ion-edit"></i></button> -->
            <!--<div class="dropdown" ngbDropdown>
              <button class="btn btn-default btn-tn btn-dropdown noarrow" type="button" ngbDropdownToggle>
                <i class="ion-more"></i>
              </button>
              <ul class="nrk-dropdown-menu" ngbDropdownMenu>
                <li class="dropdown-item" (click)="toggleSidebar(item)"><i class="ion-edit"></i>&nbsp;Edit</li>
                <li class="dropdown-item" (click)="remove(item)"><i class="ion-trash-a"></i>&nbsp;Delete</li>
              </ul>
            </div>-->
          </td>
        </tr>
        </tbody>
      </table>
    </ngx-page-container>
  </div>
</ng-sidebar-container>
